import { useEffect, useState } from 'react';
import { supabase } from './lib/supabase.js';
import Login from './components/Login.jsx';
import Layout from './components/Layout.jsx';
import MorningBriefing from './components/MorningBriefing.jsx';
import FullDash from './components/FullDash.jsx';
import Projects from './components/Projects.jsx';
import History from './components/History.jsx';

const TABS = [
  { id: 'briefing', label: 'Morning Briefing', component: MorningBriefing },
  { id: 'dash',     label: 'Full Dash',        component: FullDash },
  { id: 'projects', label: 'Projects',         component: Projects },
  { id: 'history',  label: 'History',          component: History },
];

export default function App() {
  const [session, setSession] = useState(null);
  const [bootstrapping, setBootstrapping] = useState(true);
  const [activeTab, setActiveTab] = useState('briefing');

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setBootstrapping(false);
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  if (bootstrapping) {
    return (
      <div className="flex items-center justify-center h-screen text-text-secondary">
        Loading…
      </div>
    );
  }

  if (!session) return <Login />;

  const ActiveComponent = TABS.find((t) => t.id === activeTab).component;

  return (
    <Layout
      tabs={TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      user={session.user}
      onSignOut={() => supabase.auth.signOut()}
    >
      <ActiveComponent onSwitchTab={setActiveTab} />
    </Layout>
  );
}
